import PropTypes from 'prop-types';


export const propTypes = {
  LivesNumber: PropTypes.number,
};

export const defaultProps = {
  LivesNumber: 0,
};